export default __webpack_public_path__ + "static/media/rarity-background-gradient.416ef708.svg";